
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'options'];
  static values = { emails: Array };

  connect() {
    this.matches = [];
    this.activeIndex = -1;
    this.close();
  }

  focus() {
    requestAnimationFrame(() => {
      if (document.activeElement === this.inputTarget) {
        this.renderOptions(this.emailsValue);
      }
    });
  }

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase();

    this.renderOptions(
      this.emailsValue.filter(email =>
        email.toLowerCase().includes(query)
      )
    );
  }

  renderOptions(emails) {
    this.matches = emails;
    this.activeIndex = -1;
    this.optionsTarget.replaceChildren();

    emails.forEach((email, index) => {
      const option = document.createElement('button');

      option.type = 'button';
      option.tabIndex = -1;
      option.textContent = email;
      option.className = 'block w-full px-3 py-2 text-left text-gray-900 hover:bg-gray-100';

      option.addEventListener('mousedown', event => {
        event.preventDefault();
        this.select(index);
      });

      this.optionsTarget.appendChild(option);
    });

    this.optionsTarget.classList.toggle('hidden', emails.length === 0);
  }

  select(index) {
    if (index < 0 || index >= this.matches.length) return;

    this.inputTarget.value = this.matches[index];
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }));
    this.close();
  }

  keydown(event) {
    if (event.key === 'Escape') {
      this.close();
      return;
    }

    if (this.optionsTarget.classList.contains('hidden')) return;

    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();

      const direction = event.key === 'ArrowDown' ? 1 : -1;
      const count = this.matches.length;

      this.activeIndex = (this.activeIndex + direction + count) % count;
      this.highlight();
    }

    if (event.key === 'Enter' && this.activeIndex >= 0) {
      event.preventDefault();
      this.select(this.activeIndex);
    }
  }

  highlight() {
    Array.from(this.optionsTarget.children).forEach((option, index) => {
      option.classList.toggle('bg-gray-100', index === this.activeIndex);
    });
  }

  blur() {
    this.close();
  }

  close() {
    this.optionsTarget.classList.add('hidden');
    this.activeIndex = -1;
  }
}
